import { Component, ViewChild, TemplateRef, OnInit, Input, ElementRef } from '@angular/core';
import { startOfDay, endOfDay, startOfMonth, endOfMonth, isSameDay, isSameMonth, format } from 'date-fns';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { EventColor } from 'calendar-utils';
import { NodeService } from 'src/app/shared/services/node.services';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})

export class CalendarComponent implements OnInit {
  @ViewChild('modalContent', { static: true }) modalContent!: TemplateRef<any>;
  @Input() block: any;
  @Input() lang: any;
  @Input() colonne_occupate: string = '';
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  refresh = new Subject<void>();
  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = true;
    modalData!: {
    action: string;
    event: CalendarEvent;
  };
  colors: Record<string, EventColor> = {
    brand: {
      primary: '#0B7749',
      secondary: '#DAEBE4',
    }
  };
  isMobile: boolean = false;

  constructor(
    private modal: NgbModal,
    private nodeService: NodeService,
    private router: Router,
    private el: ElementRef
  ) {}
  
  ngOnInit(): void {
    if (this.colonne_occupate <= '2') {
      setTimeout(() => {
        const dayHeaders = this.el.nativeElement.querySelectorAll('.cal-header .cal-cell');
        for (const dayHeader of dayHeaders) {
          const dayName = dayHeader.textContent.trim();
          const abbreviatedDayName = dayName.slice(0, 3);
          dayHeader.textContent = abbreviatedDayName.toUpperCase();
        }
      }, 0);
    }
    this.loadCurrentMonthEvents();
  }

  private loadCurrentMonthEvents(): void {
    const now = new Date();
    const firstDayOfMonth = startOfMonth(now);
    const lastDayOfMonth = endOfMonth(now);
    const formattedFirstDayOfMonth = format(firstDayOfMonth, 'yyyy-MM-dd');
    const formattedLastDayOfMonth = format(lastDayOfMonth, 'yyyy-MM-dd');
    this.getRowCalendar(formattedFirstDayOfMonth, formattedLastDayOfMonth, this.lang);
  }
  
  private getRowCalendar(dataFrom: string, dataTo: string, lang: string): void {
    this.events = [];
    this.nodeService.getCalendarResult(dataFrom, dataTo, lang).subscribe(result => {
      this.block = result.rows;
      for (const evento of this.block) {
        if (this.nodeService.isBrowser) {
          // Decodifica l'escaping HTML utilizzando una textarea nascosta
          const textarea = document.createElement("textarea");
          textarea.innerHTML = evento.field_titolo;
          const decodedHtml = textarea.value;
          // Estrarre solo il testo dall'HTML
          const div = document.createElement("div");
          div.innerHTML = decodedHtml;
          const title = div.textContent;
          // Verifica se le chiavi "field_data_inizio" e "field_data_fine" esistono
          if (evento.field_data_inizio && evento.field_data_fine) {
            // Estrapola le date dai valori dell'attributo datetime
            const inizioData = new Date(evento.field_data_inizio.match(/datetime="(.*?)"/)[1]);
            const fineData = new Date(evento.field_data_fine.match(/datetime="(.*?)"/)[1]);
            // Verifica se gli orari sono nel formato corretto (HH:mm)
            const orarioRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
            const inizioOrario = evento.field_orario_inizio && orarioRegex.test(evento.field_orario_inizio) ? `T${evento.field_orario_inizio}` : '';
            const fineOrario = evento.field_orario_fine && orarioRegex.test(evento.field_orario_fine) ? `T${evento.field_orario_fine}` : '';
            const start = new Date(`${inizioData.toISOString().substr(0, 10)}${inizioOrario}`);
            const end = new Date(`${fineData.toISOString().substr(0, 10)}${fineOrario}`);
            // Crea un nuovo oggetto evento con le proprietà desiderate
            const nuovoEvento: CalendarEvent = {
              title: title || '',
              start: startOfDay(start),
              end: endOfDay(end),
              allDay: !evento.field_orario_fine,
              id: this.nodeService.retriveLinkTagA(evento.field_titolo, 'a').link,
              color: this.colors['brand'],
              draggable: false
            };
            // Aggiungi il nuovo oggetto evento all'array di eventi
            this.events.push(nuovoEvento);
          }
        }
      };
      const currentDate = new Date();
      const todayEvents = this.events.filter(event => startOfDay(event.start).getTime() === startOfDay(currentDate).getTime());
      if (todayEvents.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.updateEvents();
    })
  }
  

  onViewChange(newViewDate: any): void {
    const firstDayOfMonth = startOfMonth(newViewDate);
    const lastDayOfMonth = endOfMonth(newViewDate);
    const formattedFirstDayOfMonth = format(firstDayOfMonth, 'yyyy-MM-dd');
    const formattedLastDayOfMonth = format(lastDayOfMonth, 'yyyy-MM-dd');
    this.getRowCalendar(formattedFirstDayOfMonth, formattedLastDayOfMonth, this.lang);
    this.activeDayIsOpen = false;
  }

  isSmartphone(): boolean {
    return window.innerWidth <= 767;
  }
  
  
  updateEvents(): void {
    this.events = [...this.events];
  }  

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }
  
  
  
  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.router.navigateByUrl(String(event.id));
  }

  setView(view: CalendarView) {
    this.view = view;
  }
}